import { UserRoleEnum } from '@/model/User';
import { SessionStorageEnum } from '@/utils/SessionStorageEnum';
import { RouteRecordRaw } from 'vue-router';
import { OrdersAppRoutesEnum } from './OrdersAppRoutesEnum';

const AppRequestsPage = () => import(/* webpackChunkName: "OrdersApp-module" */ '../pages/app-requests/AppRequestsPage.vue');
const AppRequestDetail = () => import(/* webpackChunkName: "OrdersApp-module" */ '../pages/app-requests/AppRequestDetail.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/app/orders',
    name: OrdersAppRoutesEnum.ORDERS_APP_PLACEHOLDER,
    component: AppRequestsPage,
    meta: {
      tabTitle: 'Ordini App',
      breadCrumbItems: [
        { label: 'Ordini App' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
    beforeEnter(_, __, next) {
      sessionStorage.removeItem(SessionStorageEnum.TABLE_STATE_APP_REQUESTS);
      next();
    },
  },
  {
    path: '/app/orders/:id',
    name: OrdersAppRoutesEnum.APP_REQUEST_DETAIL,
    component: AppRequestDetail,
    meta: {
      tabTitle: 'Dettaglio Richiesta',
      breadCrumbItems: [
        { label: 'Ordini App', to: { name: OrdersAppRoutesEnum.ORDERS_APP_PLACEHOLDER } },
        { label: 'Dettaglio' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
  },
];

export { routes };
export { OrdersAppRoutesEnum };
